<template>
    <div class="main-control">

        <v-btn @click="onClickCarouselSize()" class="minimize-carousel" color="primary" fab x-small>
            <v-icon>{{icon_carousel}}</v-icon>
        </v-btn>
            
        <v-carousel
            id="id_carousel"
            class="carousel-style"
            :show-arrows="false"
            height="425"
            cycle
            hide-delimiter-background
            delimiter-icon="brightness_1"
            :style="{width:showCaseWidth+'px'}"
            show-arrows-on-hover>
            <v-carousel-item
                v-for="(item,i) in showcaseDetails"
                :key="i"
                :src="item.url">
            
                <v-sheet
                    style="background-color: transparent !important;"
                    height="100%"
                    >   
                    <v-row v-if="isSystemAdmin || isShowcaseAdmin" align="baseline" justify="end" no-gutters>
                        <div>
                        <v-btn dark icon class="btn-top" @click="addShowcase">
                            <v-icon :color="showcaseDetails[i].captioncolor" >mdi-plus</v-icon>
                        </v-btn>
                        <v-btn dark icon class="btn-top" @click="updateShowcase(item)">
                            <v-icon :color="showcaseDetails[i].captioncolor" >mdi-cog</v-icon>
                        </v-btn>                        
                        </div>                        
                    </v-row>                 
                    <v-container                       
                        class="fill-height"
                        align="center"
                        justify="center"
                       >   
                        <v-row  align="center" justify="center">                            
                            <div class="display-3">
                                <p :style="'color:'+showcaseDetails[i].titlecolor"> 
                            {{item.title}}</p></div></v-row>     
                        <v-row  align="center" justify="center">
                            <div class="center-position">
                                <p :style="'color:'+showcaseDetails[i].descriptioncolor">
                            {{item.description}}</p></div></v-row>     
                        <v-row  align="center" justify="center">
                            <div class="btn-position">
                            <v-btn x-large dense 
                            @click="goToLearnMore(showcaseDetails[i].captionurl)" 
                            class="ma-2" 
                            :color="showcaseDetails[i].captioncolor">
                            {{ showcaseDetails[i].captionname }}</v-btn>
                        </div></v-row>                                              
                    </v-container>
                </v-sheet>
            </v-carousel-item>

        </v-carousel>

        

        <br><br>

        <v-row class="card-section" justify="center">
            <v-col
                v-for="n in cards"
                :key="n.id"
                cols="auto">
                <v-card
                    class="card-position"
                    :width="cardWidth"
                    :height="cardHeight"
                >
                    <v-img
                        class="white--text align-end backgroundCover"
                        :src="getImgUrl(n.img)">
                            <v-card-title class="white--text pl-10 pt-0">
                                 <v-btn dark icon class="btn-top" v-if="n.type == 'Data Availability' && dataAvailabilityLink.disabled" disabled>
                                     <v-icon color="white" >slideshow</v-icon>
                                </v-btn>
                                 <v-btn dark icon class="btn-top" 
                                 v-else-if="n.type == 'Data Availability' && !dataAvailabilityLink.submenu && !dataAvailabilityLink.disabled" 
                                 @click="onItemClick(dataAvailabilityLink)">
                                     <v-icon color="white" >slideshow</v-icon>
                                </v-btn>
                                <v-menu  open-on-hover offset-x v-else-if="n.type == 'Data Availability'  && dataAvailabilityLink.submenu && !dataAvailabilityLink.disabled">
                                    <template v-slot:activator="{ on, attr }">
                                <v-btn dark icon class="btn-top" v-bind="attr" v-on="on">
                                    <v-icon color="white" >slideshow</v-icon>
                                </v-btn>
                                    </template>      
                                <v-list>
                                <v-list-item
                                v-for="(menu, index) in dataAvailabilityLink.submenu"
                                :key="index"
                                @click="onItemClick(menu)"
                                >
                                <v-list-item-title>{{ menu.domain }}</v-list-item-title>
                                </v-list-item>
                                </v-list>
                                </v-menu>
                                <v-btn dark icon class="btn-top" v-else-if="n.type == 'Events'" @click="onItemClick(eventLink)" :disabled="!eventLink.url">
                                    <v-icon color="white" >slideshow</v-icon>
                                </v-btn>
                                 <v-btn dark icon class="btn-top" v-else-if="n.type == 'Knowledge Hub'" @click="onItemClick(knowledgehubLink)" :disabled="!knowledgehubLink.url">
                                    <v-icon color="white" >slideshow</v-icon>
                                </v-btn>
                            </v-card-title>
                    </v-img>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="card-section" justify="center">
            <v-col
                v-for="n in hubs"
                :key="n.id"
                cols="auto">
                <v-card
                    class="card-position"
                    :width="cardWidth"
                >

                    <v-app-bar dark color="white" class="app-bar-card black--text">
                        <v-toolbar-title :class="n.color_text" class="app-bar-card-title">{{n.title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon class="app-bar-card-icon" v-if="n.icon != undefined">
                            <v-icon class="grey--text" @click="onHubClick(n)">{{n.icon}}</v-icon>
                        </v-btn>
                    </v-app-bar>

                    <v-card-title class="card-title ">
                        <div class="title font-weight-regular_second ">{{n.subtitle}}</div>
                    </v-card-title>
                    <v-card align="center" v-if="n.title === 'Data at a Glance'">
                      <v-list-item>                          
                       <v-select
                        :items="silos"
                        @change="ChangeSilo" 
                        v-model="selectedSilo"  
                        :no-data-text = $vuetify.noDataText
                      >        
                      </v-select> 
                      </v-list-item>  
                        <div style="text-align:center;height:110px">
                       <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="150">
                       <defs>
                           <filter id="rsi_gauge_1-inner-shadow">
                               <feOffset dx="0" dy="3" />
                               <feGaussianBlur result="offset-blur" stdDeviation="5" />
                               <feComposite result="inverse" in="SourceGraphic" in2="offset-blur" operator="out" />
                               <feFlood flood-color="black" flood-opacity="0.2" result="color" />
                               <feComposite result="shadow" in="color" in2="inverse" operator="in" />
                               <feComposite in="shadow" in2="SourceGraphic" operator="over" />
                            </filter
                        ></defs>
                        <path filter="url(&quot;#rsi_gauge_1-inner-shadow&quot;)" 
                        fill="#edebeb" stroke="none" 
                        d="M 35 89.6 L 14 89.6 A 56 56 0 0 1 126 89.6 L 105 89.6 A 35 35 0 0 0 35 89.6 Z" />
                        <path filter="url(&quot;#rsi_gauge_1-inner-shadow&quot;)" 
                        :fill="progressColor" :d="progressPath"  />
                        <text font-family="Arial,sans-serif" 
                        font-size="11px" font-weight="bold" 
                        style="font: bold 11px/normal Arial,sans-serif; font-size-adjust: none; font-stretch: normal; fill-opacity: 1; text-anchor: middle;" fill="#999999" 
                        fill-opacity="1" stroke="none" text-anchor="middle" x="70" y="17.2308" font="10px &quot;Arial&quot;">
                        <tspan dy="3.6358">POS</tspan></text>
                        <text font-family="Arial,sans-serif" 
                        font-size="17px" font-weight="bold" 
                        style="font: bold 17px/normal Arial,sans-serif; font-size-adjust: none; font-stretch: normal; fill-opacity: 1; text-anchor: middle;" fill="#010101" 
                        fill-opacity="1" stroke="none" text-anchor="middle" x="70" y="80" font="10px &quot;Arial&quot;">
                        <tspan dy="5.615">{{percent}}</tspan></text>
                        <text font-family="Arial,sans-serif" 
                        font-size="10px" font-weight="normal" 
                        style="font: 10px/normal Arial,sans-serif; font-size-adjust: none; font-stretch: normal; fill-opacity: 1; text-anchor: middle;" fill="#b3b3b3" 
                        fill-opacity="1" stroke="none" text-anchor="middle" x="70" y="94.75" font="10px &quot;Arial&quot;">
                        <tspan dy="3.3">% of average</tspan></text>
                        <text font-family="Arial,sans-serif" 
                        font-size="10px" font-weight="normal" 
                        style="font: 10px/normal Arial,sans-serif; font-size-adjust: none; font-stretch: normal; fill-opacity: 1; text-anchor: middle;" fill="#b3b3b3" 
                        fill-opacity="1" stroke="none" text-anchor="middle" x="24.5" y="99.4" font="10px &quot;Arial&quot;">
                        <tspan dy="3.3">0</tspan></text>
                        <text font-family="Arial,sans-serif" 
                        font-size="10px" font-weight="normal" 
                        style="font: 10px/normal Arial,sans-serif; font-size-adjust: none; font-stretch: normal; fill-opacity: 1; text-anchor: middle;" fill="#b3b3b3" 
                        fill-opacity="1" stroke="none" text-anchor="middle" x="115.5" y="99.4" font="10px &quot;Arial&quot;">
                        <tspan dy="3.3">100</tspan></text>
                    </svg>
                        </div>
                          <v-list-item v-if="selectedSiloInfo != null">
                              <v-container no-gutters style="text-align:left">
                                  <v-row no-gutters>
                                       {{selectedSiloInfo.message}}
                                  </v-row>
                                  <v-row no-gutters>
                                      <v-col>
                                         <div class="font-weight-bold"> Completeness Rating</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                        <v-tooltip color="#feffcd" content-class="tooltip" right> 
                                            <template v-slot:activator="{ on, attrs }">
                                               <span class="tooltipElement" 
                                               v-bind="attrs" v-on="on"> {{selectedSiloInfo.completenessRating}}</span>
                                            </template>
                                            <div>The Completeness Rating compares store-item records received <br/>for the most recent date to historical averages.</div>
                                        </v-tooltip>
                                     </v-col>
                                  </v-row>
                                  <v-row no-gutters class="oddLine mt-1 mb-1">
                                      <v-col>
                                          <div class="font-weight-bold"> Last POS Transaction</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         {{selectedSiloInfo.lastPosTransaction}}
                                     </v-col>
                                  </v-row>
                                  <v-row no-gutters>
                                      <v-col>
                                          <div class="font-weight-bold"> Last Store Inventory Transaction</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         {{selectedSiloInfo.lastInvTransaction}}
                                     </v-col>
                                  </v-row>
                                  <v-row no-gutters class="oddLine mt-1 mb-1">
                                      <v-col>
                                          <div class="font-weight-bold"> Last DC Transaction</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         {{selectedSiloInfo.lastDCTransaction}}
                                     </v-col>
                                  </v-row>
                                  <v-row no-gutters>
                                      <v-col>
                                          <div class="font-weight-bold"> Last Cube Process</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         <v-tooltip color="#feffcd" content-class="tooltip" right> 
                                            <template v-slot:activator="{ on, attrs }">
                                               <span class="tooltipElement" 
                                               v-bind="attrs" v-on="on"> 
                                               {{selectedSiloInfo.lastCubeProcess!=null?selectedSiloInfo.lastCubeProcess.split(" ")[0]:""}}</span>
                                            </template>
                                         <span>{{selectedSiloInfo.lastCubeProcess}}</span>
                                        </v-tooltip>
                                     </v-col>
                                  </v-row>
                                   <v-row no-gutters class="oddLine mt-1 mb-1">
                                      <v-col>
                                          <div class="font-weight-bold"> Unique Items Scanning</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         {{selectedSiloInfo.uniqueItemScanning}}
                                          <v-tooltip color="#feffcd" contentClass="tooltip" right> 
                                            <template v-slot:activator="{ on, attrs }">
                                               <span class="tooltipElement" 
                                               v-bind="attrs" v-on="on">  ({{selectedSiloInfo.uniqueItemPctAve}}%)</span>
                                            </template>
                                         <div>Percent of average calculation:<br/><br/>(unique items scanning / average unique items scanning for last N periods) * 100 
                                         </div>
                                         <hr/>
                                         <span class="font-weight-bold"> 
                                             ({{selectedSiloInfo.uniqueItemScanning}} /  {{selectedSiloInfo.averageItemScanning}}  ) * 100 = {{ selectedSiloInfo.uniqueItemPctAve}}
                                             </span>
                                        </v-tooltip>   
                                     </v-col>
                                  </v-row>
                                   <v-row no-gutters>
                                      <v-col>
                                          <div class="font-weight-bold"> Unique Stores Scanning</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         {{selectedSiloInfo.uniqueStoreScanning}} 
                                          <v-tooltip color="#feffcd" content-class="tooltip" right> 
                                            <template v-slot:activator="{ on, attrs }">
                                               <span class="tooltipElement" v-bind="attrs" v-on="on">  
                                                   ({{selectedSiloInfo.uniqueStorePctAve}}%)</span>
                                            </template>
                                             <div>Percent of average calculation:<br/><br/>(unique stores scanning / average unique stores scanning for last N periods) * 100 
                                         </div>
                                         <hr/>
                                         <span class="font-weight-bold"> 
                                             ({{selectedSiloInfo.uniqueStoreScanning}} /  {{selectedSiloInfo.averageStoreScanning}}  ) * 100 = {{ selectedSiloInfo.uniqueStorePctAve}}
                                             </span>
                                        </v-tooltip>  
                                        
                                     </v-col>
                                  </v-row>
                                   <v-row no-gutters class="oddLine mt-1 mb-1">
                                      <v-col>
                                          <div class="font-weight-bold"> Weeks ## Loaded</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                         {{selectedSiloInfo.weeksLoaded}}
                                     </v-col>
                                  </v-row>
                                   <v-row no-gutters>
                                      <v-col>
                                          <div class="font-weight-bold"> Last Complete Date</div>
                                     </v-col>
                                     <v-col class="ml-1">
                                          <v-tooltip color="#feffcd" content-class="tooltip" right> 
                                            <template v-slot:activator="{ on, attrs }">
                                               <span class="tooltipElement" v-bind="attrs" v-on="on">  
                                                   {{selectedSiloInfo.lastCompleteDate != null?selectedSiloInfo.lastCompleteDate.split(" ")[0]:""}}
                                                   </span>
                                            </template>
                                         <span>{{selectedSiloInfo.lastCompleteDate}}</span>
                                        </v-tooltip>                      
                                     </v-col>
                                  </v-row>
                              </v-container>
                           </v-list-item>
                    </v-card>
                    <v-list v-if="n.title === 'Communication'" two-line>
                        <v-list-item
                            @click="onClickCommunication(item)"
                            v-for="item in communication"
                            :key="item.id">
                            <v-list-item-icon>
                                <v-icon :color="n.color">store</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{item.modified}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="grey">help_outline</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>

                    <v-list v-if="n.title === 'News'" two-line>
                        <v-list-item
                            @click="onItemClick(item)"
                            v-for="item in news"
                            :key="item.title">
                            <v-list-item-icon>
                                <v-icon color="primary">
                                    commute
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title :title="item.title">
                                <v-icon color="orange" v-if="isNew(item.updatedAt)">fiber_new</v-icon>
                                    {{ item.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{item.updatedAt}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="grey">help_outline</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>

        <br><br><br>


        <carousel-dailog-box
            v-if="showcase_dlg"
            v-model="showcase_dlg"
            :userType="user_type"
            :title="showcase_title"            
            :item="showcase_item"
            :isLastShowcase="isLastShowcase"
            v-on:closeCarouselDailogBox="closeCarouselDailogBox">
        </carousel-dailog-box>                
    </div>
    
</template>

<script>
    import { carousel_items } from "@/data/carousel-items.js";
    import { cards } from "@/data/cards.js";
    import { hubs } from "@/data/hubs.js";
    import { daily_overview } from "@/data/daily-overview.js";
    import { EventBus } from '../../main.js';

    import loadImageMixin from "@/mixins/loadImageMixin";
    import CarouselDailogBox from "@/dialogs/carousel-dialog-box";
    export default {
        name: "MainPage-index",
        mixins: [loadImageMixin],
        components: {
            "carousel-dailog-box": CarouselDailogBox,
        },

        created(){
            EventBus.$on("renderShowcaseDetails", ()=>{
                this.getShowcaseDetails();
             });
        },
        data() {
            return {
                icon_carousel: 'arrow_downward',

                carousel_items: [],

                cards: [],

                hubs: [],

                daily_overview: [],
                percent: 0,
                redColor: "#FF0000",
                yellowColor: "#FFCC00",
                greenColor:"#008000",
                silos: [],
                selectedSiloInfo:null,  
                selectedSilo:null ,
                showcase_dlg: false,
                showcase_item: null,
                showcase_title: null,
                showcaseImage: null,
                showcaseDetails: null,
                showcase_caption: "",
                showcase_caption_color: '',
                showcase_caption_link: "",
                user_type: null,
                isLastShowcase: false,
                windowSize: {
                    x: 0,
                    y: 0,
                },
            }
        },
        computed:{
            isSystemAdmin(){
                return this.$store.getters.getIsSystemAdmin;
            },
            isShowcaseAdmin(){
                return this.$store.getters.getIsShowcaseAdmin;
            },
            progressColor(){
                if(this.percent >= 75 && this.percent < 90){
                    return this.yellowColor;
                }else if(this.percent >= 90){
                    return this.greenColor;
                }else{
                    return  this.redColor;
                }
            },
            showCaseWidth(){
                return Math.ceil(this.windowSize.x * 0.88);
            },

            /*showcaseTitleSize(){
                console.log("this.windowSize.x: "+this.windowSize.x);
                console.log("this.windowSize.y: "+this.windowSize.y);
                const browserZoomLevel = Math.round(window.devicePixelRatio * 100);                
                if(browserZoomLevel >= 100){
                    console.log(" showcaseTitleSize : "+(this.windowSize.x  - this.windowSize.y)/(browserZoomLevel*3));
                    return (this.windowSize.x  - this.windowSize.y)/(browserZoomLevel)/3;
                }else{
                    console.log(" showcaseTitleSize : "+(this.windowSize.x  - this.windowSize.y)/((browserZoomLevel+100)*3));
                    return (this.windowSize.x  - this.windowSize.y)/((browserZoomLevel+100))/3;
                }
            },

           showcaseDescriptionSize(){
                const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
                console.log("this.windowSize.y: "+this.windowSize.y+" and this.windowSize.x: "+this.windowSize.x);
                console.log("browserZoomLevel: "+browserZoomLevel);
                if(browserZoomLevel >= 100){
                    console.log(" showcaseDescriptionSize : "+(this.windowSize.y+this.windowSize.x)/(browserZoomLevel-15));
                    return (this.windowSize.y+this.windowSize.x)/(browserZoomLevel);
                }else{
                    console.log(" showcaseDescriptionSize : "+(this.windowSize.y+this.windowSize.x)/(browserZoomLevel+100-15));
                    return (this.windowSize.y+this.windowSize.x)/(browserZoomLevel+100-10);
                }
            },*/

            cardWidth(){
                return Math.round(this.showCaseWidth/3) - 14;
            },
            cardHeight(){
                //fix edge display issue in VDI
                return Math.round(this.cardWidth/507*228);
            },
            progressPath(){
            let progress;
            if(this.percent <0 ){
                progress = 0;
            }else if(this.percent > 100){
                progress = 100;
            }else{
                progress = this.percent;
            }
                    
            const alpha = progress/100* Math.PI;
            
            const Ro = 56;
            const Ri = 35;
            
            const Cx = 70;
            const Cy = 89.6;
            const X1 = Cx - Ro * Math.cos(alpha);
            const Y1 = Cy - Ro * Math.sin(alpha);
            const X2 = Cx - Ri * Math.cos(alpha);
            const Y2 = Cy - Ri * Math.sin(alpha);
            let path = "";
        
            path += "M" + (Cx - Ri) + "," + Cy + " ";
            path += "L" + (Cx - Ro) + "," + Cy + " ";
            path += "A" + Ro + "," + Ro + " 0 0,1 " + X1 + "," + Y1 + " ";
            path += "L" + X2 + "," + Y2 + " ";
            path += "A" + Ri + "," + Ri + " 0 0,0 " + (Cx - Ri) + "," + Cy + " ";
            path += "z ";

            return path;
            },
            items(){
                return this.$store.getters.getCentralItems;
            },
            dataAvailabilityLink(){
                const link = {};
                const dataLinks = this.items.filter(item => item.name == "rsi.central.da.url");

                if (dataLinks.length == 1){
                    link.url = dataLinks[0].url
                }else if(dataLinks.length == 2){
                    link.submenu = dataLinks;
                }else{
                    link.disabled = true;
                }
                return link;
            },
            eventLink(){
                const link = {};
                const dataLinks = this.items.filter(item => item.name == "rsi.central.event.url");

                if (dataLinks.length == 1){
                    link.url = dataLinks[0].url;
                }
                return link;
            },
            knowledgehubLink(){
                const link = {};
                const dataLinks = this.items.filter(item => item.name == "rsi.central.knowledgehub.url");

                if (dataLinks.length == 1){
                    link.url = dataLinks[0].url;
                }
                return link;
            },
            communication(){
                return this.$store.getters.getLandingPageComms;
            },
            news(){
                return this.$store.getters.getNews;
            },
        },
        mounted() {
            console.log("MainPage-index.MOUNTED()");

            this.carousel_items = carousel_items;

            this.cards = cards;

            this.hubs = hubs;
            this.daily_overview = daily_overview;
            
            this.getListOfSilosOfUser();
            this.getShowcaseDetails();     
            this.getLandingPageComms();  
            this.$store.dispatch("fetchNews"); 
            //refresh notification list
            this.$store.dispatch("fetchNotificationList",{userId:this.$store.getters.getUserId});
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };    
            // Register an event listener when the Vue component is ready
            window.addEventListener('resize', this.onResize);
        },
        beforeDestroy() {
            // Unregister the event listener before destroying this Vue instance
            window.removeEventListener('resize', this.onResize);
        },
        methods: {                           
            getListOfSilosOfUser(){
                console.log("getUserSiloList(), getting silo list for userId:",this.$store.getters.getUserId)                
                this.$store.dispatch("setUserSiloList",this.$store.getters.getUserId).then(response =>{
                    this.silos = response;
                    if(this.silos.length > 0){
                        this.selectedSilo = this.silos[0];
                        this.ChangeSilo(this.selectedSilo);
                    }
                });                
            },           
            onClickCommunication(item) {
                console.log("onShowCommunicationMoreDialog(item): ", item );
                if(!item.isRead){
                    //set notification read status
                    this.$store.dispatch("getNotificationBody",{userId:this.$store.getters.getUserId,commId:item.id,isBodyRequired:false}).then(() =>{
                        //reload notification list and landing page items
                        this.$store.dispatch("fetchNotificationList",{userId:this.$store.getters.getUserId});
                        this.getLandingPageComms();  
                    });
                }
                
                this.$store.dispatch("setCommunicationDetail",item)
                this.$store.dispatch("setShowCommunication",true)
            },
            onClickCarouselSize() {
                console.log('this.icon_carousel :', this.icon_carousel);

                this.icon_carousel = this.icon_carousel === 'arrow_downward' ? 'arrow_upward' : 'arrow_downward';

                const element = document.getElementById("id_carousel");

                const status = this.icon_carousel === 'arrow_downward' ? 'block' : 'none';  
                
                console.log(status);

                element.style.display = status;
            },

            ChangeSilo(value){
                console.log('inside ChangeSilo() method with value:', value);
                this.$store.dispatch("setSiloDetails", value).then(response =>{
                    this.selectedSiloInfo = response;
                    this.percent = this.selectedSiloInfo.completenessRating;
                });               
            },
            onItemClick(item) {
             window.open(item.url, "_blank");    
           },            
            showCarouselDailogBox(item){
                console.clear();             
                this.show_carousel_item = item;
                this.show_carousel_dlg = true;
            },

            goToLearnMore(link) {
            window.open(link, "_blank");    
            },            
            updateShowcase(item){
                console.clear();            
                this.showcase_title='Update Showcase';               
                this.showcase_item = item;
                this.showcase_dlg = true;
                this.user_type = this.$store.getters.getUserInfo.userType;
            },
            addShowcase(){
                console.clear();             
                this.showcase_title = 'Add Showcase';
                this.showcase_item = [];
                this.showcase_dlg = true;
                this.user_type = this.$store.getters.getUserInfo.userType;
            },
            
            closeCarouselDailogBox(){
                this.showcase_item = null;
                this.showcase_dlg = false;
            },
            getShowcaseDetails(){
                console.log("getShowcaseDetails(), getting all showcases details")                
                this.$store.dispatch("listShowcaseDetails").then(response =>{
                    this.showcaseDetails = response;   // changed response.data              
                    this.isLastShowcase = this.showcaseDetails.length === 1 ? true : false; 
                    console.log("isLastShowcase: "+this.isLastShowcase);
                });                
            },
            openCommunicationManagement(){
                 this.$router.push("/communication/manage");
            },
            onHubClick(card){
                if(card.title == "Communication"){
                    this.openCommunicationManagement();
				}
            },
            getLandingPageComms(){
                console.log("Get landingPage communications for user");
                this.$store.dispatch("loadLandingPageComms")
            },
            formatDate(dateStr) {
                const date = new Date(dateStr);
                const year = date.getFullYear(),
                        month = date.getMonth() + 1, // months are zero indexed
                        day = date.getDate(),
                        hour = date.getHours(),
                        minute = date.getMinutes(),
                        second = date.getSeconds(),
                        hourFormatted = hour % 12 || 12, // hour returned in 24 hour format
                        minuteFormatted = minute < 10 ? "0" + minute : minute,
                        secondFormatted = second < 10 ? "0" + second : second,
                        morning = hour < 12 ? "am" : "pm";

                    return day + "/" + month + "/" + year + " " + hourFormatted + ":" +
                            minuteFormatted + ":"+ secondFormatted + " " +morning;
                },
            onResize(){
                this.windowSize = { x: window.innerWidth, y: window.innerHeight };
            },
            isNew(date){
                const today = new Date(Date.now()-(new Date()).getTimezoneOffset() * 60000)
                const days = today.getTime() - new Date(date.split('T')[0]).getTime(); 
                return ((days/(1000 * 3600 * 24)) < 7);
            }

        }
    }
</script>

<style lang="scss" scoped>
    .v-toolbar {
        //left: 56px !important;
        box-shadow: none !important;
        -webkit-box-shadow:  none !important;
    }

    .main-control {
        width: 100% !important;
        height: 100% !important;
        padding-left: 65px;
        padding-top: 24px;
        background-color: #F5F5F5;

        .minimize-carousel {
            position: absolute;
            left: 65px;
            top: 24px;
        }

        .carousel-style {
            margin-left:auto;
            margin-right: auto;
            .center-position {
                width: 90%;
                font-size: 25px;
                text-align: center;
            }

            .btn-position {
                text-align: center;
                margin-bottom: 40px;
                padding-bottom: 20px;
            }
        }

        .card-section {
            //text-shadow: 3px 3px 9px rgba(0, 0, 0, 0.6);
            //box-shadow: 3px 3px 9px rgba(0, 0, 0, 0.3);

            .card-position {
                margin-top: 18px;
                margin-left: auto;

                .btn-top {
                    position: absolute;
                    top: 18px;
                    right: 9px;
                }

                .icon-style {
                    position: absolute;
                    left: 15px;
                }

                .icon-title {
                    position: absolute;
                    font-weight: bold;
                    white-space: pre-line;
                    top: 15px;
                    left: 40px;
                }

                .subtitle {
                    font-weight: 14;
                    color: white;
                    line-height: normal;
                    word-break: normal;
                    white-space: pre-line;
                }

                .app-bar-card {
                    height: 51px !important;

                    .app-bar-card-title {
                        margin-top: -9px !important;
                    }
                    .app-bar-card-icon {
                        margin-top: -9px !important;
                    }
                }

                .divider-line {
                    border-top: 1px solid #EEEEEE;
                    width: 100%;
                }

                .card-title {
                    margin-top: -9px;

                    .icon-position {
                        margin-right: 18px;
                        margin-top: -9px;
                    }

                    .display-1 {
                        font-size: 1.5rem !important;
                        line-height: normal !important;
                    }

                    .icon-right-position {
                        position: absolute;
                        right: 18px;
                        bottom: 72px;
                    }

                    .font-weight-regular {
                        margin-top: -9px !important;
                        font-weight: 300 !important;
                        font-size: 18px !important;
                        line-height: normal;
                        word-break: break-word;
                    }

                    .font-weight-regular_second {
                        margin-top: 6px !important;
                        font-weight: 300 !important;
                        font-size: 18px !important;
                        line-height: normal;
                        word-break: break-word;
                        margin-bottom: -15px;
                    }
                }
            }
        }
    }

    .tooltipElement{
        cursor:help;
        text-decoration: underline;
    }
    .oddLine{
        background-color: #D3D3D3;
    }
</style>
<style lang="scss">
.tooltip{
    color:black !important;
    border:1px black solid;
}
.backgroundCover{
    //fix edge display issue in VDI
    background-size:cover;
    height:100%;
}
</style>